import { useMemo, useContext } from "react";
import { getCharacterStyleClasses } from "../utils/characterStyleUtils";
import PreviewContext from "../../editor/context/PreviewContext";

/**
 * Custom hook to manage character styling properties (font, text formatting, etc.)
 * @param {Object} component - Component object containing characterStyle data
 * @returns {Object} - Object containing style classes and inline style objects
 */
const useCharacterStyle = (component = null) => {
  const preview = useContext(PreviewContext);
  const { styleClasses, inlineStyles } = useMemo(() => {
    if (!component) {
      return { styleClasses: "", inlineStyles: {} };
    }

    const characterStyleData =
      component.characterStyle || component.character_style || null;

    if (!characterStyleData) {
      return { styleClasses: "", inlineStyles: {} };
    }

    const { className, style } = getCharacterStyleClasses(characterStyleData, preview);
    return {
      styleClasses: className || "",
      inlineStyles: style || {},
    };
  }, [component, preview?.mode, preview?.viewport?.width, preview?.contentWidth]);

  return {
    styleClasses,
    inlineStyles,
  };
};

export default useCharacterStyle;
